import {
  Create,
  Form,
  Input,
  InputNumber,
  Select,
  Switch,
  useForm,
  useSelect,
} from "@pankod/refine-antd";
import { IResourceComponentsProps } from "@pankod/refine-core";
import { useState } from "react";
import "react-mde/lib/styles/css/react-mde-all.css";
import "./styles.scss";
import { ILabel } from "types/label.interface";

export const OptionReleasePricingCreate: React.FC<
  IResourceComponentsProps
> = () => {
  const [minPrice, setMinPrice] = useState<number>(0);
  const [maxPrice, setMaxPrice] = useState<number>(500);
  const [minTracks, setMinTracks] = useState<number>(0);
  const [maxTracks, setMaxTracks] = useState<number>(500);

  const { formProps, saveButtonProps, formLoading } = useForm<{
    minPrice: number;
    maxPrice: number;
    minTracks: number;
    maxTracks: number;
    name: string;
    labels: Array<ILabel>;
    isMixinit: boolean;
  }>();

  const { selectProps: LabelSelectProps } = useSelect<ILabel>({
    resource: "labels",
    fetchSize: 100,
    optionLabel: "name",
    optionValue: "_id",
  });

  // const selectProps = useSelect<ILabel>({
  //     resource: 'labels',
  //     fetchSize: 100,
  //     optionLabel: 'name',
  //     optionValue: '_id',
  // });

  // console.log(LabelSelectProps, '5656565');

  return (
    <Create saveButtonProps={saveButtonProps} isLoading={formLoading}>
      <div style={{ display: "flex", height: "100%" }}>
        <Form {...formProps} layout="vertical" style={{ width: "100%" }}>
          <Form.Item
            label="Name"
            name="name"
            rules={[
              {
                required: true,
                message: "Name is required",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <div className="edit-title">
            <Form.Item
              className="edit-item w48"
              label="Min Tracks"
              name="minTracks"
              rules={[
                {
                  required: true,
                  message: "Min Tracks is required",
                },
                {
                  min: 1,
                  type: "number",
                  message: "Min Tracks must be more than 0",
                },
                {
                  validator: (_, value) => {
                    if (value && maxTracks && value > maxTracks) {
                      return Promise.reject(
                        new Error(
                          "Min Tracks must be less than or equal to Max Tracks"
                        )
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <InputNumber onChange={(value: number) => setMinTracks(value)} />
            </Form.Item>
            <Form.Item
              className="edit-item w48"
              label="Max Tracks"
              name="maxTracks"
              rules={[
                {
                  required: true,
                  message: "Max Tracks is required",
                },
                {
                  min: 1,
                  type: "number",
                  message: "Max Tracks must be more than 0",
                },
                {
                  validator: (_, value) => {
                    if (value && minTracks && value < minTracks) {
                      return Promise.reject(
                        new Error(
                          "Max Tracks must be greater than or equal to Min Tracks"
                        )
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <InputNumber onChange={(value: number) => setMaxTracks(value)} />
            </Form.Item>
          </div>
          <div>
            <div>
              <div className="edit-title">
                <Form.Item
                  className="edit-item w48"
                  label="Min Price"
                  name="minPrice"
                  rules={[
                    {
                      required: true,
                      message: "Min Price is required",
                    },
                    {
                      min: 1,
                      type: "number",
                      message: "Min Price must be 0 or more",
                    },
                    {
                      validator: (_, value) => {
                        if (value && maxPrice && value > maxPrice) {
                          return Promise.reject(
                            new Error(
                              "Min Price must be less than or equal to Max Price"
                            )
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <InputNumber
                    onChange={(value: number) => setMinPrice(value)}
                  />
                </Form.Item>
                <Form.Item
                  className="edit-item w48"
                  label="Max Price"
                  name="maxPrice"
                  rules={[
                    {
                      required: true,
                      message: "Max Price is required",
                    },
                    {
                      min: 1,
                      type: "number",
                      message: "Max Price must be 0 or more",
                    },
                    {
                      validator: (_, value) => {
                        if (value && minPrice && value < minPrice) {
                          return Promise.reject(
                            new Error(
                              "Max Price must be greater than or equal to Min Price"
                            )
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <InputNumber
                    onChange={(value: number) => setMaxPrice(value)}
                  />
                </Form.Item>
              </div>
            </div>
          </div>
          {/* <Form.Item
                        label='Labels'
                        name='labels'
                        rules={[
                            {
                                type: 'array',
                                min: 2,
                            },
                            {
                                required: true,
                                message: 'Labels is required',
                            },
                        ]}
                    >
                        <Select mode='multiple' options={selectProps?.options} />
                    </Form.Item> */}
          {/* <Form.Item
                        label='Labels'
                        name='labels'
                        rules={[
                            {
                                type: 'array',
                                min: 1,
                            },
                            {
                                required: true,
                                message: 'Labels is required',
                            },
                        ]}
                    >
                        <Select {...LabelSelectProps} />
                    </Form.Item> */}
          <Form.Item
            label="Labels"
            name="labels"
            rules={[
              {
                type: "array",
                min: 1,
              },
              {
                required: true,
                message: "Labels is required",
              },
            ]}
          >
            <Select mode="multiple" {...LabelSelectProps} />
          </Form.Item>
          <Form.Item
            className="edit-item w48"
            label="Is Active"
            name="isActive"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Switch defaultChecked />
          </Form.Item>
          <Form.Item
            className="edit-item w48"
            label="Is Mixinit"
            name="isMixinit"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Switch defaultChecked={false} />
          </Form.Item>
        </Form>
      </div>
    </Create>
  );
};
